import { h } from 'preact'

import s from './OppslutningLoading.module.css'
import { Message } from '../../../../lib/intl/Message'
import { Geografi, isParti, Parti } from '../../../domain'
import { TabHeading } from '../../shared/Tabs/TabHeading'
import { TabPanel, Tabs } from '../../shared/Tabs/Tabs'
import { OppslutningLoadingTable } from './OppslutningLoadingTable/OppslutningLoadingTable'

type Props = {
  grunndata: Geografi | Parti
}

export function OppslutningLoading(props: Props) {
  const { navn } = props.grunndata
  const type = isParti(props.grunndata) ? 'steder' : 'partier'

  function onChange() {}

  return (
    <section class={s.oppslutningLoading}>
      <h3>
        <Message id="oppslutning-tittel" values={{ navn }} />
      </h3>
      <Tabs
        onChange={onChange}
        headings={[
          <TabHeading icon="tab-stemmer">
            <Message id={`oppslutning-tab-tittel-oppslutning`} />
          </TabHeading>,
          <TabHeading icon="tab-endring" disabled>
            <Message id={`oppslutning-tab-tittel-endring`} />
          </TabHeading>
        ]}
      >
        <TabPanel hidden={false}>
          <OppslutningLoadingTable type={type} minimumShowing={10} toggleShowMore={() => {}} />
        </TabPanel>
        <TabPanel hidden={true} />
      </Tabs>
    </section>
  )
}
